import $ from 'jquery';

$(function () {

    $('.accordion .accordion__title').on('click', function() {

        // Get the main accordion element
        const $accordion = $(this).parent();

        // Display new accordion
        $accordion.toggleClass('active');
        $accordion.find('.accordion__content').slideToggle();

    });

});